import type { Activity } from '$lib/api/restApi';
import type RestApiClient from '$lib/api/restApi';
import type { Hub, HubsAPI, Post, User, Widget } from '$lib/api/rpc';
import type { Collection, CustomCollection } from '$lib/types/Collections';
import { getContext, setContext } from 'svelte';
import type { Writable } from 'svelte/store';
import { writable } from 'svelte/store';
import type { Pod } from '$lib/types/Pod';

export const key = {};

export interface HubStores {
	user: Writable<User>;
	hub: Writable<Hub>;
	posts: Writable<Array<Post>>;
	featuredPosts: Writable<Array<Post>>;
	pinnedPosts: Writable<Array<Post>>;
	collaborators: Writable<Array<User>>;
	/**
	 * Note: If the All collection is visible, it will be in the the collections array.
	 */
	collections: Writable<Array<Collection>>;
	archivedCollections: Writable<Array<CustomCollection>>;
	widgets: Writable<Array<Widget>>;
	activities: Writable<Array<Activity>>;
	api: HubsAPI;
	restApi: RestApiClient;
	pod: Pod;
	alidaJwt?: string;
}

export const getHubStores = (): HubStores => {
	return getContext(key);
};

interface InitData {
	user?: User;
	hub?: Hub;
	posts?: Array<Post>;
	featuredPosts?: Array<Post>;
	pinnedPosts?: Array<Post>;
	collaborators?: Array<User>;
	collections?: Array<Collection>;
	archivedCollections?: Array<Collection>;
	widgets?: Array<Widget>;
	activities?: Array<Activity>;
	api: HubsAPI;
	restApi: RestApiClient;
	pod: Pod;
	alidaJwt?: string;
}

export const setHubStores = ({
	user,
	hub,
	posts,
	featuredPosts,
	pinnedPosts,
	collaborators,
	collections,
	archivedCollections,
	widgets,
	activities,
	api,
	restApi,
	pod,
	alidaJwt,
}: InitData): void => {
	setContext(key, {
		user: writable<User>(user),
		hub: writable<Hub>(hub),
		posts: writable<Array<Post>>(posts || []),
		featuredPosts: writable<Array<Post>>(featuredPosts || []),
		pinnedPosts: writable<Array<Post>>(pinnedPosts || []),
		collaborators: writable<Array<User>>(collaborators || []),
		collections: writable<Array<Collection>>(collections || []),
		archivedCollections: writable<Array<Collection>>(archivedCollections || []),
		widgets: writable<Array<Widget>>(widgets || []),
		activities: writable<Array<Activity>>(activities || []),
		api,
		restApi,
		pod,
		alidaJwt,
	});
};
